"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShoppingCheckoutRequest = instanceOfShoppingCheckoutRequest;
exports.ShoppingCheckoutRequestFromJSON = ShoppingCheckoutRequestFromJSON;
exports.ShoppingCheckoutRequestFromJSONTyped = ShoppingCheckoutRequestFromJSONTyped;
exports.ShoppingCheckoutRequestToJSON = ShoppingCheckoutRequestToJSON;
exports.ShoppingCheckoutRequestToJSONTyped = ShoppingCheckoutRequestToJSONTyped;
const ProductPromotionsDiscountViewModel_1 = require("./ProductPromotionsDiscountViewModel");
const ShoppingCheckoutItem_1 = require("./ShoppingCheckoutItem");
/**
 * Check if a given object implements the ShoppingCheckoutRequest interface.
 */
function instanceOfShoppingCheckoutRequest(value) {
    return true;
}
function ShoppingCheckoutRequestFromJSON(json) {
    return ShoppingCheckoutRequestFromJSONTyped(json, false);
}
function ShoppingCheckoutRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'member': json['member'] == null ? undefined : json['member'],
        'name': json['name'] == null ? undefined : json['name'],
        'cell': json['cell'] == null ? undefined : json['cell'],
        'email': json['email'] == null ? undefined : json['email'],
        'address': json['address'] == null ? undefined : json['address'],
        'memoDesc': json['memoDesc'] == null ? undefined : json['memoDesc'],
        'productsTotal': json['productsTotal'] == null ? undefined : json['productsTotal'],
        'couponDiscount': json['couponDiscount'] == null ? undefined : json['couponDiscount'],
        'finalTotal': json['finalTotal'] == null ? undefined : json['finalTotal'],
        'packingWay': json['packingWay'] == null ? undefined : json['packingWay'],
        'pickupMethod': json['pickupMethod'] == null ? undefined : json['pickupMethod'],
        'bookNo': json['bookNo'] == null ? undefined : json['bookNo'],
        'items': json['items'] == null ? undefined : (json['items'].map(ShoppingCheckoutItem_1.ShoppingCheckoutItemFromJSON)),
        'coupons': json['coupons'] == null ? undefined : (json['coupons'].map(ProductPromotionsDiscountViewModel_1.ProductPromotionsDiscountViewModelFromJSON)),
    };
}
function ShoppingCheckoutRequestToJSON(json) {
    return ShoppingCheckoutRequestToJSONTyped(json, false);
}
function ShoppingCheckoutRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'member': value['member'],
        'name': value['name'],
        'cell': value['cell'],
        'email': value['email'],
        'address': value['address'],
        'memoDesc': value['memoDesc'],
        'productsTotal': value['productsTotal'],
        'couponDiscount': value['couponDiscount'],
        'finalTotal': value['finalTotal'],
        'packingWay': value['packingWay'],
        'pickupMethod': value['pickupMethod'],
        'bookNo': value['bookNo'],
        'items': value['items'] == null ? undefined : (value['items'].map(ShoppingCheckoutItem_1.ShoppingCheckoutItemToJSON)),
        'coupons': value['coupons'] == null ? undefined : (value['coupons'].map(ProductPromotionsDiscountViewModel_1.ProductPromotionsDiscountViewModelToJSON)),
    };
}
